import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserControllerService } from 'src/app/services/user-controller.service';

@Component({
  selector: 'app-candidates',
  templateUrl: './candidates.component.html',
  styleUrls: ['./candidates.component.scss']
})
export class CandidatesComponent implements OnInit {
  candidates = [];

  constructor(private _candidates: UserControllerService,
    private router: Router) { }

  tokeninfo = <any>JSON.parse(atob(sessionStorage.getItem('token')!.split('.')[1]))
  role = this.tokeninfo.role

  ngOnInit(): void {
    this._candidates.getCandidates({}).subscribe(resolve => {
      console.log(resolve)
      if (this.role == 1) {
        let myarray = []
        this.candidates = []
        for (let res of resolve) {
          for (let list of res.candidates) {
            if (list.username.split('-')[1] == '') {
              myarray.push(list)
            }
          }
        }
        for (let k = 0; k < myarray.length; k++) {
          this.removeRepeated(resolve, myarray[k])
        }
        this.candidates = resolve
      } else {
        console.log(resolve)
        let myarray = [];
        for (let list of resolve) {
          if (list.username.split('-')[1] == '') {
            myarray.push(list)
          }
        }
        for (let j = 0; j < myarray.length; j++) {
          this.removeRepeatedRec(resolve, myarray[j])
        }
        this.candidates = resolve
      }

    })
  }

  removeRepeated(resolve, myarray) {
    let coords = []
    for (let i = 0; i < resolve.length; i++) {
      for (let j = 0; j < resolve[i].candidates.length; j++) {
        if (myarray.username.split('-')[0] == resolve[i].candidates[j].username) {
          coords = [i, j]
        }
      }
    }
    resolve[coords[0]].candidates.splice(coords[1], 1)
  }

  removeRepeatedRec(resolve, myarray) {
    let coords = 0
    for (let i = 0; i < resolve.length; i++) {
      if (myarray.username.split('-')[0] == resolve[i].username) {
        coords = i
      }
    }
    resolve.splice(coords, 1)
  }

  newCandidate() {
    this.router.navigate(['/homeuser/welcome'])
  }

  activateUser(candidate) {

    this._candidates.changeUserStatus(candidate).subscribe(resolve => {
      console.log(resolve)
      this.ngOnInit()

    },
      error => {
        console.log(error)
      })
  }

}
